export default __webpack_public_path__ + "static/media/token-pocket.6f4992e3.svg";